/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForDailyCostReport extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForDailyCostReport");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForDailyCostReport.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForDailyCostReport>): BackgroundJobPayloadForDailyCostReport {
        let obj = Object.assign(new BackgroundJobPayloadForDailyCostReport(), model);
        BackgroundJobPayloadForDailyCostReport.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForDailyCostReport>): BackgroundJobPayloadForDailyCostReport {
        if (!model) return null;
        return BackgroundJobPayloadForDailyCostReport.newInstance(<BackgroundJobPayloadForDailyCostReport> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForDailyCostReport) {
        if (!obj) return;

        models.BackgroundJobPayloadForDailyCostReport.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForDailyCostReport): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForDailyCostReport.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    service_account_id: string;

}
